import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { setIsFetching } from "../../../Redux/commonReducer"
import { getHowItWas, createHowItWas, deleteHowItWas, setHowItWasData, updateHowItWas } from "../../../Redux/howItWasReducer"
import Preloader from "../../Common/Preloader/Preloader"
import AdminLayout from "../../UI/Admin/AdminLayout/AdminLayout"
import PageHeader from "../../UI/Admin/PageHeader/PageHeader"
import AddHowItWas from "./AddHowItWas"
import EditHowItWas from "./EditHowItWas"
import HowItWas from "./HowItWas"
import AdminDeleteModal from "../../UI/Admin/AdminDeleteModal/AdminDeleteModal"

const HowItWasContainer = (props) => {
    const { 
        isFetching,
        getHowItWas,
        howItWas,
        createHowItWas,
        setIsFetching,
        deleteHowItWas,
        setHowItWasData,
        updateHowItWas
    } = props

    const [currentItem, setCurrentItem] = useState(null)

    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [isOpenRemove, setIsOpenRemove] = useState(false)

    const handleOpenAdd = () => {
        setIsOpenAdd(!isOpenAdd)
    }

    const handleOpenEdit = (item) => {
        setCurrentItem(item)
        setIsOpenEdit(!isOpenEdit)
    }

    const handleOpenRemove = (item) => {
        setCurrentItem(item)
        setIsOpenRemove(!isOpenRemove)
    }

    const handleAdd = (data) => {
        createHowItWas(data).then(response => {
            if(response) {
                const newHowItWas = [...howItWas]
                newHowItWas.push(response)
                setHowItWasData(newHowItWas)
                handleOpenAdd()
            }
        })
    }

    const handleEdit = (id, data) => {
        updateHowItWas(id, data).then(response => {
            if (response) {
                const newHowItWas = [...howItWas]
                const index = newHowItWas.findIndex(el => el._id === id)
                newHowItWas[index] = response
                setHowItWasData(newHowItWas)
            }
        })
    }

    const handleRemove = (howItWasId) => {
        deleteHowItWas(howItWasId).then((status) => {
            if(status) {
                const newHowItWas = [...howItWas]
                newHowItWas.forEach((item, index) => {
                    if(item._id === howItWasId){
                        newHowItWas.splice(index, 1)
                    }
                })
                setIsOpenRemove(false)
                setHowItWasData(newHowItWas)
            }
        })
    }

    useEffect(() => {
        getHowItWas()
    }, [])

    return (
        <AdminLayout>
            <PageHeader
                title="How it Was"
                searchBar={false}
                onAddClick={handleOpenAdd}
            />
            {isOpenAdd && <AddHowItWas onClose={handleOpenAdd} createHowItWas={handleAdd} setIsFetching={setIsFetching}/>}
            {isOpenEdit && <EditHowItWas onClose={handleOpenEdit} updateHowItWas={handleEdit} setIsFetching={setIsFetching} initialData={currentItem}/>}
            {isOpenRemove && (
                <AdminDeleteModal
                    deleteItem={handleRemove}
                    onClose={handleOpenRemove}
                    onRemove={handleOpenRemove}
                    item={currentItem}
                    name={currentItem.name}
                />
            )}
            {isFetching && <Preloader/>}
            <HowItWas
                howItWasList={howItWas}
                handleRemove={handleOpenRemove}
                handleEdit={handleOpenEdit}
            />
        </AdminLayout>
    )
}

let mapStateToProps = (state) => ({
    isFetching: state.common.isFetching,
    howItWas: state.howItWas.howItWas
})

export default connect(mapStateToProps, {
    getHowItWas,
    createHowItWas,
    setIsFetching,
    deleteHowItWas,
    setHowItWasData,
    updateHowItWas
})(HowItWasContainer)